var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartenza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.43 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 27.75,
    y: 19.21,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.75,
    y: 10.65,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.18,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.43,29.87H0V0H38.43V29.87ZM2.18,27.7H36.25V2.18H2.18V27.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.17,
    y: 2.09,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.18,
    y: 2.09,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 10.68,
    y: 2.09,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 27.75,
    y: 2.09,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.17,
    y: 19.21,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.18,
    y: 19.21,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 10.68,
    y: 19.21,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 2.17,
    y: 10.65,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 19.18,
    y: 10.65,
    width: 8.51,
    height: 8.52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.68,
    y: 10.65,
    width: 8.51,
    height: 8.52
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartenza);
export default __webpack_public_path__ + "static/media/Partenza.9c6238028c973d87666cb2cd5ab88eea.svg";
export { ForwardRef as ReactComponent };